<template>
    <div class="container mx-auto py-4 px-6">
        <Head title="Reports"/>
        <h1 class="mb-8 text-3xl font-bold">Reports</h1>
        <div class="bg-white rounded-lg shadow overflow-hidden">
            <div class="flex items-center justify-between py-4 px-6">
                <div>
                    <span v-text="monthNames[month]" class="text-lg font-bold text-gray-800"/>
                    <span v-text="year" class="ml-1 text-lg text-gray-600 font-normal"/>
                </div>
                <div class="border rounded-lg px-1 pt-1">
                    <button type="button"
                            class="leading-none rounded-lg transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 items-center focus:outline-none"
                            :class="{'cursor-not-allowed opacity-25': month === 0 }" :disabled="month === 0"
                            @click="month--">
                        <ArrowLeftIcon class="h-6 w-6 text-gray-500 inline-flex leading-none"/>
                    </button>
                    <div class="border-r inline-flex h-6"></div>
                    <button type="button"
                            class="leading-none rounded-lg transition ease-in-out duration-100 inline-flex items-center cursor-pointer hover:bg-gray-200 p-1 focus:outline-none"
                            :class="{'cursor-not-allowed opacity-25': month === 11 }" :disabled="month === 11"
                            @click="month++">
                        <ArrowRightIcon class="h-6 w-6 text-gray-500 inline-flex leading-none"/>
                    </button>
                </div>
            </div>
            <div class="-mx-1 -mb-1">
                <div class="flex flex-wrap -mb-8" style="margin-bottom: -30px;">
                    <template v-for="day in days">
                        <div class="px-2 py-2 w-48">
                            <div v-text="day"
                                 class="text-gray-600 text-sm uppercase tracking-wide font-bold text-left mb-1"></div>
                        </div>
                    </template>
                </div>

                <div class="flex flex-wrap border-t border-l">
                    <template v-for="emptyDay in emptyDays">
                        <div class="text-left border-r border-b px-4 pt-2 h-32 w-48"></div>
                    </template>
                    <template v-for="(date, dateIndex) in noOfDays">
                        <div class="px-4 pt-2 border-r border-b relative h-32 w-48">
                            <div v-text="date"
                                 class="inline-flex w-6 h-6 items-center justify-center cursor-pointer text-center leading-none rounded-full transition ease-in-out duration-100"
                                 :class="{'bg-blue-500 text-white': isToday(date) === true, 'text-gray-700 hover:bg-blue-200': isToday(date) === false }"></div>
                            <div class="overflow-y-auto mt-1 h-20">
                                <template
                                    v-for="event in events.filter(e => new Date(e.event_date).toDateString() ===  new Date(year, month, date).toDateString() )">
                                    <div
                                        @click="showDayModal(event)"
                                        class="px-2 py-1 rounded-lg mt-1 overflow-hidden border" :class="{
                                                'border-blue-200 text-blue-800 bg-blue-100': event.event_theme === 'blue',
                                                'border-red-200 text-red-800 bg-red-100': event.event_theme === 'red',
                                                'border-yellow-200 text-yellow-800 bg-yellow-100': event.event_theme === 'yellow',
                                                'border-green-200 text-green-800 bg-green-100': event.event_theme === 'green',
                                                'border-purple-200 text-purple-800 bg-purple-100': event.event_theme === 'purple'
                                            }">
                                        <p v-text="event.event_title" class="text-sm truncate leading-tight"/>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <CalendarModal
            :show="showModal"
            :calendarEvent="selectedEvent"
            @update:show="showModal = $event"
        />
    </div>
</template>


<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import {ArrowRightIcon, ArrowLeftIcon} from '@heroicons/vue/24/solid'
import CalendarModal from "@/Component/CalendarModal";

export default {
    components: {
        CalendarModal,
        Head,
        ArrowRightIcon,
        ArrowLeftIcon
    },
    props: {
        orders: Array
    },
    layout: Layout,
    data() {
        return {
            showModal: false,
            selectedEvent: {},
            today: new Date(),
            month: new Date().getMonth(),
            year: new Date().getFullYear(),
            days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            events: [],
            themes: [
                {value: "blue", label: "Blue Theme"},
                {value: "red", label: "Red Theme"},
                {value: "yellow", label: "Yellow Theme"},
                {value: "green", label: "Green Theme"},
                {value: "purple", label: "Purple Theme"}
            ],
            openModal: false
        };
    },
    computed: {
        monthNames() {
            return [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
        },
        noOfDays() {
            return new Array(new Date(this.year, this.month + 1, 0).getDate()).fill(null).map((_, i) => i + 1);
        },
        emptyDays() {
            return new Array(new Date(this.year, this.month).getDay()).fill(null);
        }
    },
    methods: {
        isToday(date) {
            const d = new Date(this.year, this.month, date);
            return this.today.toDateString() === d.toDateString();
        },
        showDayModal(event) {
            this.selectedEvent = event
            this.showModal = true
        },
        eventTitle(order) {
            return `${order.name}<br/>Телефон: ${order.phone}<br/>Озеро: ${order.lake?.name ?? ''}<br/>Місце: ${order.point?.number ?? ''}<br/>Тип: ${order.type?.name ?? ''}`;
        }
    },
    mounted() {
        this.events = this.orders.map(order => ({
            event_date: new Date(order.start_date),
            modal_title: this.eventTitle(order),
            event_title: `${order.name} Телефон: ${order.phone}`,
            event_theme: "yellow"
        }));
    }
}
</script>
